/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {enums} from './enums';

export const HolidayBehavior = yup.string().oneOf(enums.HolidayBehavior.keys);
// export type IHolidayBehavior = typeof enums.HolidayBehavior[0]; // yup.InferType<typeof HolidayBehavior>;
